import Button from '../../Button';
import {ReactNode, useEffect} from 'react';
import {useIntl} from 'react-intl';
import teamGuideLeft from '@/assets/img/teamGuideLeft.png';
import teamGuideRight from '@/assets/img/teamGuideRight.png';
import styles from './index.module.scss';

interface guideProps {
    type: 'head' | 'directory';
    content: string | ReactNode;
    title?: string | ReactNode;
    offset?: number; // 整体偏移量
    arrowOffset?: number; // 箭头偏移量
    className?: string;
    handleClick?: (e: Event) => void;
    onKnownHandle?(params?: unknown): void;
}

function GuideItem(props: guideProps) {

    const {
        title, content,
        className, onKnownHandle, type, handleClick,
    } = props;

    function handleGuideClick(e: any) {
        handleClick && handleClick(e);
    }
    return (
        <div
            className={`${styles.root} ${className}`}
            style={{backgroundImage: `url(${type === 'head' ? teamGuideRight : teamGuideLeft})`}}
            onClick={handleGuideClick}
        >
            {title && <div className={styles.title}>{title}</div>}
            <div className={styles.content}>{content}</div>
            <div className={styles.buttonbox}>
                <Button onClick={onKnownHandle} className={styles.knowButton}>
                    知道了
                </Button>
            </div>
        </div>
    );
}

interface guide {
    type: 'head' | 'directory';
    className?: string;
    onKnownHandle?(params?: unknown): void;
    // handleClick?(e: Event): void;
}

export default function Guide(props: guide) {
    const intl = useIntl();
    const {className, onKnownHandle, type} = props;

    async function onClickHandle(e: Event) {
        e.stopPropagation();
        onKnownHandle && onKnownHandle();
    }
    function handleClick(e: Event) {
        e.stopPropagation();
    }
    useEffect(() => {
        return () => {
            onKnownHandle && onKnownHandle();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function custom() {
        return (
            <>
                <div className="top-text">{intl.formatMessage({id: 'addDirectoryIntro'})}</div>
                <div className="top-text">{intl.formatMessage({id: 'addDirectoryIntroOne'})}</div>
                <div className="top-text">{intl.formatMessage({id: 'addDirectoryIntroTwo'})}</div>
            </>
        );
    }
    return (<GuideItem
        className={className}
        type={type}
        title={intl.formatMessage({id: 'addDirectoryGuideTitle'})}
        content={custom()}
        // placement={'right'}
        onKnownHandle={onClickHandle}
        handleClick={handleClick}
    />);
}
